/** True when the site is already opened as an installed home-screen app. */
export function isPwaStandalone() {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.matchMedia('(display-mode: fullscreen)').matches ||
    window.navigator.standalone === true
  );
}

export function isIosDevice() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (/iphone|ipad|ipod/i.test(ua)) return true;
  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
}

export function isAndroidDevice() {
  if (typeof navigator === 'undefined') return false;
  return /android/i.test(navigator.userAgent || '');
}

/** iOS Chrome/Facebook/etc. — Add to Home Screen works best in Safari. */
export function isIosNonSafari() {
  if (!isIosDevice()) return false;
  const ua = navigator.userAgent || '';
  return !/safari/i.test(ua) || /crios|fxios|edgios|gsa|fbav|instagram/i.test(ua);
}

export function canOfferPwaInstall() {
  if (isPwaStandalone()) return false;
  return isIosDevice() || isAndroidDevice();
}
